import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledTableHeaderCell = styled.div `
    display: none;
    font-weight: 600;
    color: ${props => props.theme.primary.base};
    padding-right: 10px;
    max-width: ${props => props.maxWidth || 'none'};

    &:last-child {
        padding-right: 0;
    }

    @media only screen and (min-width: 992px) {
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: ${props => props.align};
    }
`;
const TableHeaderCell = ({ maxWidth, align = 'left', ...restProps }) => (_jsx(StyledTableHeaderCell, { maxWidth: maxWidth, align: align, ...restProps }));
export default TableHeaderCell;
